import {type ProjectTemplate} from '../types.js'

const cleanTemplate: ProjectTemplate = {}

export default cleanTemplate
